export default __webpack_public_path__ + "static/media/plata.ec251bf8.png";